/* eslint-disable sort-keys */
export default {
  light: {
    "form-field-caption": "neutral-200",
    "form-field-disabled": "neutral-500",
    "form-field-error": "tertiary-500",
    "form-field-label": "primary-200",
  },
  dark: {
    "form-field-caption": "primary-900",
    "form-field-disabled": "neutral-500",
    "form-field-error": "danger-700",
    "form-field-label": "primary-900",
  },
};
